import React, { useState, useMemo } from "react";
import classNames from "classnames";
import "@/assets/styles/components/_package-selection.styles.scss";
// import Info from "@/assets/svg/info.svg";
import { Package } from "@/screens/dashboard/_components/PackageSelection/packageSelection.types.ts";
import { PPPNames, PackageType } from "@/constants/index.ts";

export const PackageSelection: React.FC<{
  selectedPackage: string | null;
  onPackageSelect: (packageId: string) => void;
  selectedOption: string;
  filteredPackages: Package[];
}> = ({
  selectedOption,
  selectedPackage,
  onPackageSelect,
  filteredPackages,
}) => {
  const [activeTab, setActiveTab] = useState("");

  const { meetingPackages, momentaryPackages } = useMemo(() => {
    const meetingPackages = filteredPackages.filter(
      (pkg) => pkg?.appointment === true,
    );
    const momentaryPackages = filteredPackages.filter(
      (pkg) => pkg?.appointment === false,
    );

    const hasMomentary = meetingPackages.length > 0;
    const initialTab = hasMomentary
      ? PackageType.MEETING
      : PackageType.MOMENTARY;

    setActiveTab(initialTab);

    return {
      meetingPackages,
      momentaryPackages,
      defaultTab: initialTab,
    };
  }, [filteredPackages]);

  const handleTabChange = (tab: PackageType) => {
    setActiveTab(tab);
  };

  const packageMap = {
    [PPPNames.GOT_IT]: {
      [PackageType.MEETING]: meetingPackages,
      [PackageType.MOMENTARY]: momentaryPackages,
    },
  };

  const currentPackages =
    selectedOption === PPPNames.GOT_IT
      ? packageMap[selectedOption][
          activeTab as keyof (typeof packageMap)[typeof PPPNames.GOT_IT]
      ]
      : filteredPackages;

  const shouldShowTabs = selectedOption === PPPNames.GOT_IT;

  if (!filteredPackages || filteredPackages.length === 0) {
    return (
      <div className="section-content-package-selection">
        <div className="section-intro">
          <h3 className="content-title">Paket Seçimi</h3>
          <p className="content-description">
            Seçilen uygulama için paket bulunamadı.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="section-content-package-selection">
      {/* <div className="validity-info top">
        <img src={Info} alt={"Info Icon"} />
        <span className="validity-text">
          <span>Geçerlilik Süresi:</span> doping hafıza eğitim... bittiğinde...
          unc justo adipiscing massa amet a facilisis lacus sapien tortor risus
        </span>
      </div> */}

      <div className="section-intro">
        <h3 className="content-title">Paket Seçimi</h3>
        {/* <p className="content-description">
          Viverra porta eget tortor maecenas elit sagittis ultrices dignissim
          non. In cursus neque ut ac id dictum.
        </p> */}
      </div>

      {shouldShowTabs && (
        <div className="tabs-container">
          {meetingPackages?.length > 0 && (
            <button
              className={classNames("tab-button", {
                active: activeTab === PackageType.MEETING,
              })}
              onClick={() => handleTabChange(PackageType.MEETING)}
            >
              Randevulu Özel Ders
            </button>
          )}
          {momentaryPackages?.length > 0 && (
            <button
              className={classNames("tab-button", {
                active: activeTab === PackageType.MOMENTARY,
              })}
              onClick={() => handleTabChange(PackageType.MOMENTARY)}
            >
              Anlık Özel Ders
            </button>
          )}
        </div>
      )}

      <div className="packages-grid">
        {currentPackages.map((pkg) => {
          const isSelected = selectedPackage === pkg?.id;

          return (
            <div
              key={pkg?.id}
              className={classNames("package-card", {
                selected: isSelected,
                popular: pkg?.isPopular,
              })}
              onClick={() => onPackageSelect(pkg.id)}
            >
              {pkg?.isPopular && (
                <div className="popular-badge">En Uygun Fiyatlı</div>
              )}

              <div className="package-header">
                <div className="package-price">{pkg?.price}₺</div>
              </div>

              <p className="package-description">{pkg?.description}</p>

              <button
                className={classNames("package-button", {
                  selected: isSelected,
                })}
              >
                Paketi Seç
              </button>
            </div>
          );
        })}
      </div>

      {/* <div className="validity-info">
        <img src={Info} alt={"Info Icon"} />
        <span className="validity-text">
          <span>Geçerlilik Süresi:</span> doping hafıza eğitim... bittiğinde...
          unc justo adipiscing massa amet a facilisis lacus sapien tortor risus
        </span>
      </div> */}
    </div>
  );
};
